<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>

    <el-row v-if="normalMode" class="mt-20">
      <el-col :xs="24" :sm="24" :lg="24">
        <el-button type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
        </el-button>
      </el-col>
    </el-row>
    
    <el-row v-if="normalMode">
      <el-col :xs="24" :sm="24" :lg="24" style="padding: 20px 10px 20px 30px;">
        <el-tabs v-model="activeName" >
          <el-tab-pane label="用品資料" name="basicInfo">
            
            <!-- 基本資料 -->
            <el-card class="box-card">
               <el-form label-position="top" :model="form">
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="地區">
                      {{form.area}}
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="類型">
                      {{form.itemTypeLabel}}
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="名稱">
                      {{form.itemName}}
                    </el-form-item>
                  </el-col>
                  
                  
                </el-row>
              </el-form>
            </el-card>
            <!-- end 基本資料 -->

           <el-card class="box-card mt-20">
            <div slot="header" class="clearfix">
              <span>出入庫資料</span>
              <el-button  style="float: right; padding: 5px 12px" 　type="primary"
                         @click.prevent="handleAddItem" class="mr-20" id="add_item_btn">新增入庫</el-button>
            </div>
            <div>
              <el-table :data="checkinData" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="時間" prop="createdAt">
                  <template slot-scope="scope">
                    {{scope.row.createdAt | fmtDate}}
                  </template>
                </el-table-column>
                <el-table-column label="出入庫">
                  <template slot-scope="scope">
                    <p v-if="scope.row.action === '入庫'"><font color='#409EFF'>{{scope.row.action}}</font></p>
                    <p v-if="scope.row.action === '出庫'"><font color='red'>{{scope.row.action}}</font></p>
                  </template>
                </el-table-column>
                <el-table-column label="數量" prop="qty">
                  <template slot-scope="scope">
                    <p v-if="scope.row.action === '入庫'">{{scope.row.qty}}</p>
                    <p v-if="scope.row.action === '出庫'">-{{scope.row.qty}}</p>
                  </template>
                </el-table-column>
                <el-table-column label="說明">
                  <template slot-scope="scope">
                    <div v-html="fmtNotes(scope.row.notes)"></div>
                    <div v-if="scope.row.qtyUpdateNotes !== null" class="mt-10">------------</div>
                    <div v-html="fmtNotes(scope.row.qtyUpdateNotes)"></div>
                  </template>
                </el-table-column>
                <el-table-column label="小計">
                  <template slot-scope="scope">
                    <span class="mr-20">{{scope.row.currentStock}}</span>
                  

                    <el-button v-if="scope.row.action === '入庫'"　type="primary" circle @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>

                  </template>
                </el-table-column>

                <!-- <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆資料嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                       @confirm="handleDelete(scope.row.id)"
                    >
                      <el-button  type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </el-card>

          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-row v-if="addMode">
      <el-main style="background-color: white;">
        <el-form :model="checkin_form" :rules="rules" ref="checkin_form" label-position="top">
          <el-col :xs="24" :sm="24" :lg="8">
            <el-form-item label="入庫日期" prop="createdAt" >
              <el-date-picker type="date" placeholder="選擇日期" v-model="checkin_form.createdAt"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-form-item label="數量" prop="qty">
              <el-input-number v-model="checkin_form.qty"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-form-item label="說明" prop="notes">
              <el-input type="textarea" v-model="checkin_form.notes"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div style="float: right;">
          <el-button @click="cancelAddCheckin">取 消</el-button>
          <el-button type="primary" @click="saveCheckInData('checkin_form')">儲　存</el-button>
        </div>
      </el-main>
    </el-row>


    <el-row v-if="editMode">
      <el-main style="background-color: white;">
        <el-form :model="edit_checkin_form" :rules="rules" ref="edit_checkin_form" label-position="top">
          <el-col :xs="24" :sm="24" :lg="8">
            <el-form-item label="入庫日期" prop="createdAt" >
              <el-date-picker :disabled="true" type="date" placeholder="選擇日期" v-model="edit_checkin_form.createdAt"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-form-item label="數量" prop="qty">
              <el-input-number v-model="edit_checkin_form.qty"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-form-item label="說明" prop="notes">
              <el-input type="textarea" v-model="edit_checkin_form.notes"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div style="float: right;">
          <el-button @click="cancelEditCheckin">取 消</el-button>
          <el-button type="primary" @click="saveEditCheckInData('edit_checkin_form')">儲　存</el-button>
        </div>
      </el-main>
    </el-row>

    <el-dialog
      title="提醒"
      :visible.sync="dialogVisible"
      :width="dw"
      :before-close="handleClose">
      <span>請確認入庫資料是否正確?</span>
      <p class="mt-10">日期: {{checkin_form.createdAt | fmtDate}}</p>
      <p class="mt-10">數量: {{checkin_form.qty}}</p>
      <p class="mt-10">說明: {{checkin_form.notes}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">否</el-button>
        <el-button type="primary" @click="handleCheckin">是</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提醒"
      :visible.sync="edit_dialogVisible"
      :width="dw"
      :before-close="edit_handleClose">
      <span>請確認要更新的資料是否正確?</span>
      <p class="mt-10">數量: {{edit_checkin_form.qty}}</p>
      <p class="mt-10">說明: {{edit_checkin_form.notes}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_dialogVisible = false">否</el-button>
        <el-button type="primary" @click="edit_handleCheckin">是</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import dayjs from "dayjs"


export default {
  name: "ProductDetail",
  components: {
    Breadcrumb
  },
  data() {
    let fieldRequired = (rule, value, callback) => {
      console.log('fieldRequired valur:', value)
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      dw: '60%',
      
      dialogVisible : false,
      edit_dialogVisible : false,

      normalMode: true,
      addMode: false,
      editMode: false,

      activeName: 'basicInfo',
      /**上頁接收的參數**/
      id:'',

      checkinData:[],

      tableData:[],
      
      /**入庫資料表單**/
      form: {
        
      },

      /**入庫表單**/
      checkin_form: {
        id:'',
        createdAt:'',
        itemId:'',
        action:'入庫',
        qty:1,
        notes:''
      },

      edit_checkin_form: {
        id:'',
        createdAt:'',
        itemId:'',
        action:'入庫',
        qty:1,
        notes:''
      },

      rules: {
        createdAt: [{required: true, validator: fieldRequired, trigger: 'change'}]
      }

    }
  },
  methods: {

    handleDelete(id){
      this.request.delete("/item/checkin/" + id).then(res => {
        if (res.code === '200') {
          this.getItemCheckInInfo()
          this.showResult('success', '資料刪除成功')
        } else {
          this.showResult('error', '資料刪除失敗')
        }
      })
    },

    handleAddItem(){
      this.inAddMode()
    },

    handleClose(){
      this.dialogVisible = false
    },
    edit_handleClose(){
      this.edit_dialogVisible = false
    },
    

    goBack(){
      this.$router.push('/items/maintain')
    },

    getItemInfo() {
      this.request.get("/item/" + this.id).then(res => {
        if (res.code === '200') {
          this.form = res.data
          this.getItemCheckInInfo()
        }
      })
    },

    /**入庫資料**/
    getItemCheckInInfo() {
      this.request.get("/item/checkin/" + this.id).then(res => {
        if (res.code === '200') {
          this.checkinData = res.data
        }
      })
    },

    cancelAddCheckin() {
      this.$refs['checkin_form'].resetFields()
      
      this.inNormalMode()
    },
    cancelEditCheckin() {
     // this.$refs['edit_checkin_form'].resetFields()
      this.getItemCheckInInfo()
      this.inNormalMode()
    },
    handleEdit(rowData) {
      this.inEditMode()

      this.edit_checkin_form = rowData

      console.log(rowData)

    },
    saveCheckInData(formName) {
      this.$refs[formName].validate( valid => {
        if (valid) {
          this.dialogVisible = true
        }
      })
    },
    saveEditCheckInData(formName) {
      this.$refs[formName].validate( valid => {
        if (valid) {
          this.edit_dialogVisible = true
        }
      })
    },
    
    handleCheckin() {
      this.dialogVisible = false
      this.request.post("/item/checkin", this.checkin_form).then(res => {
        if (res.code === '200') {
          this.$refs['checkin_form'].resetFields()
          this.inNormalMode()
          this.$nextTick(()=>{
            this.getItemCheckInInfo()
            this.showResult('success', '資料更新成功')
          })
        }
      })
    },
    edit_handleCheckin(){
        this.edit_dialogVisible = false
        this.inNormalMode()
        this.request.post("/item/edit/checkin", this.edit_checkin_form).then(res => {
          if (res.code === '200') {
            //this.$refs['edit_checkin_form'].resetFields()
            this.inNormalMode()
            this.$nextTick(()=>{
              this.getItemCheckInInfo()
              this.showResult('success', '資料更新成功')
            })
          }
        })
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = '400'; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },

    inNormalMode(){
      this.normalMode = true
      this.addMode = false
      this.editMode = false
    },
    inAddMode(){
      this.normalMode = false
      this.addMode = true
      this.editMode = false
    },
    inEditMode(){
      this.normalMode = false
      this.addMode = false
      this.editMode = true
    },
    
  },
  mounted() {
    this.inNormalMode()
    this.id = this.$route.params.id
    this.checkin_form.itemId = this.$route.params.id

    this.getItemInfo()
    this.setDialogWidth();
    
    
  }
}
</script>

<style scoped>


</style>
